<template>

  <section id="article-section" class="article-section">
      <div class="container">
        <div class="article-box">
          <div class="row">
            <div class="col-md-6">
              <div class="article-content">
                <h1>{{data.title}}</h1>
                <p>{{data.subtitle}}</p>
                <a :href="data.link" download class="button no-rad primaryskinBg small">{{data.buttom}}</a>
              </div>
            </div>
            <div class="col-md-6">
              <img src="upload/blog/3.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>
</template>

<script>
export default {
  name: 'Article',
  props: {
    data: Object
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
